import React from 'react';
import highmarkLogo from 'assets/highmark-logo.svg';
import { useIntl } from '@leagueplatform/locales';
import { FooterLinkItems, LandingPage } from '@highmark-web/highmark-common';
import { useFooterLinks } from 'hooks/use-footer-links';
import { APP_STORE_PROD_URL, PLAY_STORE_PROD_URL } from 'common/constants';

export const BrandedLandingPage = () => {
  const { formatMessage } = useIntl();
  const landingGreeting = formatMessage({ id: 'GREETINGS_SUBHEADING' });
  const buttonText = formatMessage({ id: 'CONTINUE_TO_APP' });
  const authErrorText = formatMessage({ id: 'ERROR_CAPTION_BACKEND' });
  const { footerLinks } = useFooterLinks();

  return (
    <LandingPage
      logo={highmarkLogo}
      landingGreeting={landingGreeting}
      buttonText={buttonText}
      authErrorText={authErrorText}
      footer={<FooterLinkItems linkItems={footerLinks} />}
      appDownloadBadges={{
        appStoreUrl: APP_STORE_PROD_URL,
        playStoreUrl: PLAY_STORE_PROD_URL,
      }}
    />
  );
};
